module.exports = __webpack_public_path__ + "img/green-apple-and-celery-granita.fcd8562b.jpg";